import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from "@/layout/index.vue"
Vue.use(VueRouter)

const routes = [{
		path: "/",
		component: layout,
		children: [{
				path: '',
				name: 'Index',
				component: () => import('@/views/index/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'news',
				name: 'news-list',
				component: () => import('@/views/news/list.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'notice',
				name: 'notice-list',
				component: () => import('@/views/notice/list.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'article/detail',
				name: 'article-detail',
				component: () => import('@/views/article/detail.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'unit/profile',
				name: 'unit-profile',
				component: () => import('@/views/unit/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'party/building',
				name: 'party-building',
				component: () => import('@/views/party/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'kotter',
				name: 'Kotter',
				component: () => import('@/views/kotter/list.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'farme',
				name: 'Farme',
				component: () => import('@/views/kotter/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'affairs',
				name: 'affairs-list',
				component: () => import('@/views/affairs/list.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'variety',
				name: 'Variety',
				component: () => import('@/views/variety/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'variety/detail',
				name: 'variety-detail',
				component: () => import('@/views/variety/detail.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'leader/detail',
				name: 'leader-detail',
				component: () => import('@/views/unit/leader-detail.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'technology',
				name: 'achievement-list',
				component: () => import('@/views/achievement/list.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'search',
				name: 'search-list',
				component: () => import('@/views/search/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'achievement',
				name: 'achievement-index',
				component: () => import('@/views/achievement/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'platform',
				name: 'platform-index',
				component: () => import('@/views/achievement/platform.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'repository',
				name: 'repository',
				component: () => import('@/views/repository/index.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			},
			{
				path: 'video/detail',
				name: 'video-detail',
				component: () => import('@/views/video/detail.vue'),
				meta: {
					isKeepAlive: true,
					isAffix: true,
				},
			}
		]
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/login/login.vue'),
	},
	{
		path: '/voice',
		name: 'voice-detail',
		component: () => import('@/views/voice/voice.vue'),
		meta: {
			isKeepAlive: true,
			isAffix: true,
		},
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router